import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

const slideIn = keyframes`
  from { transform: translateX(100%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

export const ToastWrapper = styled.div`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  z-index: 9999;
`;

export const StyledToast = styled.div<{
  $type: "success" | "error" | "info" | "warning";
  $isClosing: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 300px;
  padding: 1rem 1.25rem;
  background-color: ${({ theme }) => theme.colors.surface};
  border-left: 4px solid
    ${({ theme, $type }) => {
      if ($type === "success") return theme.colors.success;
      if ($type === "error") return theme.colors.danger;
      if ($type === "warning") return theme.colors.warning;
      return theme.colors.primary;
    }};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  color: ${({ theme }) => theme.colors.text};
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  font-weight: 500;

  animation: ${({ $isClosing }) => ($isClosing ? fadeOut : slideIn)} 0.3s
    forwards;
`;

export const IconWrapper = styled.div<{
  $type: "success" | "error" | "info" | "warning";
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme, $type }) => {
    if ($type === "success") return theme.colors.success;
    if ($type === "error") return theme.colors.danger;
    if ($type === "warning") return theme.colors.warning;
    return theme.colors.primary;
  }};
`;
